import {
    getMerchantSettings,
    saveMerchantSettings,
  } from "../../services/MerchantSettingService";
  import {formatError, formatSuccess} from '../../services/commonServices'
  export const MERCHANT_SETTING_LOADING = "MERCHANT_SETTING_LOADING";
  export const MERCHANT_SETTING_SUCCESS = "MERCHANT_SETTING_SUCCESS";
  export const MERCHANT_SETTING_FAILURE = "MERCHANT_SETTING_FAILURE";
  
  export const loadMerchantSettings = () => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_SETTING_LOADING });
  
      getMerchantSettings()
        .then((res) => {
          dispatch({
            type: MERCHANT_SETTING_SUCCESS,
            payload: res.data[0],
          });
        })
        .catch((error) => {
          dispatch({
            type: MERCHANT_SETTING_FAILURE,
            payload: formatError(error),
          });
        });
    };
  };
  
  export const saveMerchantSettingsAction = (data) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_SETTING_LOADING });
  
      return saveMerchantSettings(data)
        .then((res) => {
          dispatch({
            type: MERCHANT_SETTING_SUCCESS,
            payload: res.data,
          });
          formatSuccess('Merchant API Settings',res)
        })
        .catch((error) => {
          dispatch({
            type: MERCHANT_SETTING_FAILURE,
            payload: formatError(error),
          });
        });
    };
  };